var _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeployedCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11,19.4v-6.9L5,9.1v6.9L11,19.4z M13,19.4l6-3.5V9.1l-6,3.5V19.4z M12,10.8l5.9-3.4L12,4L6.1,7.4L12,10.8z M4,17.7 c-0.3-0.2-0.6-0.4-0.7-0.7S3,16.3,3,16V8c0-0.4,0.1-0.7,0.3-1C3.4,6.7,3.7,6.5,4,6.3l7-4C11.3,2.1,11.7,2,12,2c0.4,0,0.7,0.1,1,0.3 l7,4c0.3,0.2,0.6,0.4,0.7,0.7C20.9,7.3,21,7.7,21,8V16c0,0.4-0.1,0.7-0.3,1c-0.2,0.3-0.4,0.5-0.7,0.7l-7,4c-0.3,0.2-0.6,0.3-1,0.3 c-0.3,0-0.7-0.1-1-0.3L4,17.7z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "5,9.1 5,15.9 11,19.4 11,12.6 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeployedCode);
export default __webpack_public_path__ + "static/media/deployed_code.3b47fe5a4eb74f2aa8e69da85cf47a00.svg";
export { ForwardRef as ReactComponent };